module.exports = __webpack_public_path__ + "img/item_icon2.088c5222.png";